<template>


<!-- NOTE: Ersetze SubPageHeader
<WorkPackageSubPageModule/> -->

<!-- NOTE: Die beiden Buttons in den drei Kreisen oben rechts
:header_options="[
  {description: 'Download', icon: 'download', show: true},
  {description: 'Unlink', icon: 'link-variant-off', show: /*TODO: unlink codnition*/ true},
]" -->

<!-- NOTE: Link (z. B. Workpackage) Eingabefeld TODO: Wenn deaktiviert - Hover → Pointer
<DropDownOutlinedFlat
  label="Link"
  :options="image_link_types"
  :value="{text: image_link.text, value: image_link.value}"
  :is_disabled="!(isEditMode || is_create)"
  :background_color="workpackage_bg_hex"
  :foreground_color="workpackage_fg_hex"
  @change="changeImageLinkType($event)"
  @click.native="(isEditMode || is_create)?'':$router.push({
    name: `${location}WorkPackage${image_link.name_for_route}StepsDetails`,
    params: {
      content_id: image_link.id
    }
    })"
  style="width: 100%;"
/> -->

  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <!-- HEADER -->
      <!-- NOTE: Das hier wird komplett ersetzt -->
      <SubpageHeader
        :is_sticky="true"
        :is_create_screen="is_new_qr"
        :background_color="bg"
        :foreground_color="fg"
        @backBtnClicked="test()"
        @saveBtnClicked="test('save')"
        @cancelBtnClicked="test('cancel')"
      >
      </SubpageHeader>

      <!-- ACTUAL CONTENT -->
      <div class="work-package-qr-detail-container">
        <div
          class="work-package-qr-detail-content"
          :style="is_new_qr ? 'margin-top: 20px' : ''"
        >
          <!-- NAVIGATION -->
          <div v-if="!is_new_qr" class="work-package-qr-detail-naviagtion">
            <!-- SHOW PREVIOUS -->
            <button
              class="work-package-qr-detail-navigation-button"
              :style="`border-color:${fg};`"
              v-ripple
              @click="updateCurrentIndex(-1)"
            >
              <v-icon :color="fg">
                mdi-arrow-left-thick
              </v-icon>
            </button>
            <!-- QR NUMBER -->
            <TText
              :text="`${current_index + 1}/${qr_codes.length}`"
              :size="14"
              :color="fg"
            />
            <!-- SHOW NEXT -->
            <button
              class="work-package-qr-detail-navigation-button"
              :style="`border-color:${fg};`"
              v-ripple
              @click="updateCurrentIndex(1)"
            >
              <v-icon :color="fg">
                mdi-arrow-right-thick
              </v-icon>
            </button>
          </div>
          <TIcon
            name="qr-code"
            :color="fg"
            size="64"
            style="align-self: center;"
          />

          <!-- TEXT FIELDS -->
          <div class="work-package-qr-detail-text-fields">
            <!-- DESCRIPTION -->
            <DisableableInputField
              class="mt-2 mb-2"
              label="Description"
              :value="qr_codes[current_index].description"
              :is_disabled="true"
              :background_color="bg"
              :foreground_color="fg"
            />
            <!-- STEP TYPE -->
            <DisableableInputField
              v-if="!is_edit_mode && !is_new_qr"
              class="mt-2 mb-2"
              label="Link"
              :value="qr_codes[current_index].link"
              placeholder="No link"
              :is_disabled="true"
              :background_color="bg"
              :foreground_color="fg"
            />
            <!-- NOTE: DropDownOutlinedFlat hier -->
            <!-- <DropDown
              v-else
              label="Link"
              :items="[
                'LOGISTIC.step', 'DESIGN.step', 'WORK.step',
                'QUALITY.step', 'DEFECT.step', 'HANDOVER.step',
                'MATERIAL.step', 'TOOL.step', 'SENSOR.step',
                'ROBOTICS.step'
              ]"
              :default_item="qr_codes[current_index].link"
              placeholder="Choose a link..."
              :clearable="true"
              padding="0 0 16px 0"
              :light="is_light_mode(fg)"
              :background_color="bg"
              :foreground_color="fg"
              @selected="handleStepTypeUpdate($event)"
            /> -->
            <!-- PERSON -->
            <DisableableInputField
              class="mt-2 mb-2"
              label="Person"
              :value="qr_codes[current_index].person"
              :is_disabled="true"
              :background_color="bg"
              :foreground_color="fg"
            />
            <!-- DATE -->
            <DisableableInputField
              class="mt-2 mb-2"
              label="Date"
              :value="qr_codes[current_index].date"
              :is_disabled="true"
              :background_color="bg"
              :foreground_color="fg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
// import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';

  export default {
    components: {
      SubpageHeader,
      TText,
      TIcon,
      // DropDown,
      DisableableInputField,
    },

    mixins: [
      WorkPackageWIPMixin,
    ],

    computed: {

    },

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      cancel_color: '#F44336', // TODO: no colors in work packages

      current_index: 0,
      is_edit_mode: false,
      is_new_qr: false,

      delta_foreground_color: '',
      delta_light_mode: '',

      // NOTE: these are supposed to be in the store or at least be loaded into it when necessary
      // qr_codes: [
      //   {
      //     description: 'Felsen',
      //     link: 'ROBOTICS.step',
      //     step: 'My Step 1',
      //     date: '2021-10-21',
      //     person: 'Timo Vogelsang',
      //   },
      // ]
      qr_codes: [
        { description: 'EEEEEEEEEE', link: 'WORK.package', date: '2021-12-23 07:07:27 UTC', person: 'Narko Wegrollt', },
        { description: 'EFEEEEEEEE', link: 'WORK.package', date: '2021-12-23 08:06:28 UTC', person: 'Marco Herold', },
        { description: 'FFFFFFFFFF', link: 'WORK.package', date: '2021-12-23 09:05:29 UTC', person: 'Marco Herold', },
        { description: 'G1G1G1G1G1', link: 'WORK.package', date: '2021-12-23 10:04:30 UTC', person: 'Narko Wegrollt', },
        { description: 'ZZZXXXYYYA', link: 'WORK.package', date: '2021-12-23 11:03:31 UTC', person: 'Marco Herold', },
        { description: 'AAAAAAAAAA', link: 'WORK.package', date: '2021-12-23 12:02:32 UTC', person: 'Yusao Zeroten-Powerspike', },
      ],
    }),

    methods: {
      // Navigates between qr_codes
      updateCurrentIndex(val) {
        let index = this.current_index + val;
        if(index < 0) {
          this.current_index = this.qr_codes.length - 1;
        }
        else if(index >= this.qr_codes.length) {
          this.current_index = 0;
        }
        else {
          this.current_index = index;
        }
      },

      // TODO: this needs to mutate store
      handleStepTypeUpdate(new_value) {
        this.qr_codes[this.current_index].link = new_value;
        // if another step type is chosen the current step needs to be resetted either way
        // TODO: also needs to mutate
        this.qr_codes[this.current_index].step = '';
      },

      // TODO: this needs to mutate store
      handleStepUpdate(new_value) {
        this.qr_codes[this.current_index].step = new_value;
      },
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
    margin-top: 0;
  }
  .work-package-qr-detail-container {
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
  }
  .work-package-qr-detail-head {
    display: flex;
    justify-content: space-between;
  }
  .work-package-qr-detail-head-spacer {
    margin-top: 30px; /* 10px from frame, 20px from margin */
  }
  .work-package-qr-detail-content {
    margin: 0 20px;
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
  }
  .work-package-qr-detail-naviagtion {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .work-package-qr-detail-navigation-button {
    width: 50px;
    height: 50px;
    border: 1px solid;
    border-radius: 4px;
  }
  .work-package-qr-detail-img {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .25);
  }
  .work-package-qr-detail-text-fields {
    display: flex;
    flex-direction: column;
    padding-top: 8px;
  }
  .work-package-qr-detail-new-qr {
    display: flex;
    width: 100%;
    /* justify-content: space-between; */
    justify-content: center;
    grid-gap: 24px;
  }
</style>
